import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: [
      'absolute left-0 m-0! w-full px-[32px] py-[16px]',
      'bottom-[calc(-1*var(--form-message-height,72px))] opacity-0',
      'data-[state=open]:bottom-0 data-[state=open]:animate-[form-message-enter_0.3s_ease-out] data-[state=open]:opacity-100',
      'data-[state=closed]:animate-[form-message-exit_0.3s_ease-out]'
    ],
    message: 'text-s font-regular leading-[140%] text-white'
  },
  variants: {
    status: {
      success: {
        base: 'bg-bg-items-black'
      },
      error: {
        base: 'bg-bg-items-error'
      }
    }
  },
  defaultVariants: {
    status: 'success'
  }
});
